import _classCallCheck from "/Users/hart/dev/applications/personal-website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/Users/hart/dev/applications/personal-website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { getRangeValue, getValue, itemFromSingleOrMultiple, loadParticlesOptions, randomInRange, setRangeValue } from "tsparticles-engine";
import { Destroy } from "./Options/Classes/Destroy";
export var DestroyUpdater = /*#__PURE__*/function () {
  function DestroyUpdater(engine, container) {
    _classCallCheck(this, DestroyUpdater);

    this.engine = engine;
    this.container = container;
  }

  _createClass(DestroyUpdater, [{
    key: "init",
    value: function init(particle) {
      var container = this.container,
          particlesOptions = particle.options,
          destroyOptions = particlesOptions.destroy;

      if (!destroyOptions) {
        return;
      }

      particle.splitCount = 0;
      var destroyBounds = destroyOptions.bounds;

      if (!particle.destroyBounds) {
        particle.destroyBounds = {};
      }

      if (destroyBounds.bottom) {
        particle.destroyBounds.bottom = getRangeValue(destroyBounds.bottom) * container.canvas.size.height / 100;
      }

      if (destroyBounds.left) {
        particle.destroyBounds.left = getRangeValue(destroyBounds.left) * container.canvas.size.width / 100;
      }

      if (destroyBounds.right) {
        particle.destroyBounds.right = getRangeValue(destroyBounds.right) * container.canvas.size.width / 100;
      }

      if (destroyBounds.top) {
        particle.destroyBounds.top = getRangeValue(destroyBounds.top) * container.canvas.size.height / 100;
      }
    }
  }, {
    key: "isEnabled",
    value: function isEnabled(particle) {
      return !particle.destroyed;
    }
  }, {
    key: "loadOptions",
    value: function loadOptions(options) {
      if (!options.destroy) {
        options.destroy = new Destroy();
      }

      for (var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        sources[_key - 1] = arguments[_key];
      }

      for (var _i = 0, _sources = sources; _i < _sources.length; _i++) {
        var source = _sources[_i];
        options.destroy.load(source === null || source === void 0 ? void 0 : source.destroy);
      }
    }
  }, {
    key: "particleDestroyed",
    value: function particleDestroyed(particle, override) {
      if (override) {
        return;
      }

      var destroyOptions = particle.options.destroy;

      if (destroyOptions && destroyOptions.mode === "split") {
        this.split(particle);
      }
    }
  }, {
    key: "update",
    value: function update(particle) {
      if (!this.isEnabled(particle)) {
        return;
      }

      var position = particle.getPosition(),
          bounds = particle.destroyBounds;

      if (!bounds) {
        return;
      }

      if (bounds.bottom !== undefined && position.y >= bounds.bottom || bounds.left !== undefined && position.x <= bounds.left || bounds.right !== undefined && position.x >= bounds.right || bounds.top !== undefined && position.y <= bounds.top) {
        particle.destroy();
      }
    }
  }, {
    key: "addSplitParticle",
    value: function addSplitParticle(parent, splitParticlesOptions) {
      var destroyOptions = parent.options.destroy;

      if (!destroyOptions) {
        return;
      }

      var splitOptions = destroyOptions.split,
          options = loadParticlesOptions(this.engine, this.container, parent.options),
          factor = getValue(splitOptions.factor);
      options.color.load({
        value: {
          hsl: parent.getFillColor()
        }
      });
      options.move.load({
        center: {
          x: parent.position.x,
          y: parent.position.y,
          mode: "precise"
        }
      });

      if (typeof options.size.value === "number") {
        options.size.value /= factor;
      } else {
        options.size.value.min /= factor;
        options.size.value.max /= factor;
      }

      options.load(splitParticlesOptions);
      var offset = splitOptions.sizeOffset ? setRangeValue(-parent.size.value, parent.size.value) : 0,
          position = {
        x: parent.position.x + randomInRange(offset),
        y: parent.position.y + randomInRange(offset)
      };
      return this.container.particles.addParticle(position, options, parent.group, function (particle) {
        var _a;

        if (particle.size.value < 0.5) {
          return false;
        }

        particle.velocity.length = randomInRange(setRangeValue(parent.velocity.length, particle.velocity.length));
        particle.splitCount = ((_a = parent.splitCount) !== null && _a !== void 0 ? _a : 0) + 1;
        particle.unbreakable = true;
        setTimeout(function () {
          particle.unbreakable = false;
        }, 500);
        return true;
      });
    }
  }, {
    key: "split",
    value: function split(particle) {
      var destroyOptions = particle.options.destroy;

      if (!destroyOptions) {
        return;
      }

      var splitOptions = destroyOptions.split;

      if (splitOptions.count >= 0 && (particle.splitCount === undefined || particle.splitCount++ > splitOptions.count)) {
        return;
      }

      var rate = getValue(splitOptions.rate),
          particlesSplitOptions = itemFromSingleOrMultiple(splitOptions.particles);

      for (var i = 0; i < rate; i++) {
        this.addSplitParticle(particle, particlesSplitOptions);
      }
    }
  }]);

  return DestroyUpdater;
}();